import './find-your-trip.scss'

const selectors = {
  researchModule: '[data-fyt]',
  researchModuleTrigger: '[data-fyt-trigger]',

  clearButton: '[data-fyt-clear]',
  submitButton: '.fyt__form-submit',

  researchModuleValues: '[data-fyt-values]',
  researchModuleValuesParameter: '[data-fyt-values-parameter]',
  researchModuleValuesContainer: '[data-fyt-values-container]',

  researchModuleAccordion: '[data-fyt-accordion]',

  researchModuleTabs: '[data-fyt-tabs]',
  researchModuleTabsHeader: 'data-fyt-tabs-header',
  researchModuleTabsPane: 'data-fyt-tabs-pane',

  researchModuleResult: '.fyt__result',

  input: 'input',

  active: 'active',
  itemSelected: 'item-selected',
  loading: 'loading',

  pagination: '.pagination',
}

let checkboxesSnapshot = null
let prevResultWasPagination = false

const form = document.querySelector(selectors.researchModule)

const sendRequest = (panes, activeIndex, paged, isPaginationRequest) => {
  const formValues = new FormData(form)
  let params = null
  if (isPaginationRequest && checkboxesSnapshot) {
    if (checkboxesSnapshot) {
      params = checkboxesSnapshot
    } else {
      params = [...formValues.entries()].reduce((res, [name, value]) => [...res, `${name}=${value}`], []).join('&')
      checkboxesSnapshot = params
    }
    prevResultWasPagination = true
    window.scrollTo(0, 0)
  } else {
    if (prevResultWasPagination) {
      params = checkboxesSnapshot
      prevResultWasPagination = false
    } else {
      params = [...formValues.entries()].reduce((res, [name, value]) => [...res, `${name}=${value}`], []).join('&')
      checkboxesSnapshot = params
    }
  }

  const resultContainer = document.querySelector(selectors.researchModuleResult)

  formValues.append('params', params)
  formValues.append('action', 'home_filter')
  formValues.append('nonce', window['ajax_settings'].nonce)
  paged ? formValues.append('paged', paged) : null

  //if (!params) return
  if (panes && activeIndex) {
    panes[activeIndex].classList.add(selectors.loading)
  }

  form.classList.add('loading')
  resultContainer.classList.add('loading')

  const url = window['ajax_settings'].url
  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    body: formValues,
  })
    .then((res) => {
      return res.json()
    })
    .then((res) => {
      if (!res['is_filter_query']) {
        const inputs = document.querySelectorAll('input[type="checkbox"]')
        inputs.forEach((input) => {
          let isAvailable = null
          if (input.name === 'bike') {
            isAvailable = res[input.name]?.includes(!!input.value)
          } else {
            isAvailable = res[input.name]?.includes(input.value)
          }
          if (isAvailable) {
            input.removeAttribute('disabled')
          } else {
            input.setAttribute('disabled', '')
          }
        })
      } else {
        const inputs = document.querySelectorAll('input[type="checkbox"]')
        inputs.forEach((input) => {
          input.removeAttribute('disabled')
        })
      }

      resultContainer.innerHTML = res['grid_markup'] + res['pagination_markup']
    })
    .finally(() => {
      if (panes && activeIndex) {
        panes[activeIndex].classList.remove(selectors.loading)
      }
      form.classList.remove('loading')
      resultContainer.classList.remove('loading')
    })
}

const handleAccordionClick = (accordions, activeIndex) => {
  accordions.forEach((accordion, index) => {
    const isActive = accordion.getAttribute('data-fyt-accordion')

    accordion.setAttribute('data-fyt-accordion', activeIndex === index ? (!isActive ? selectors.active : '') : '')
  })
  sendRequest(accordions, activeIndex)
}

const initAccordions = (accordions) => {
  accordions?.forEach((accordion, activeIndex) => {
    const accordionHeader = accordion.firstElementChild

    accordionHeader.addEventListener('click', () => handleAccordionClick(accordions, activeIndex))
  })
}

const initCheckboxes = (checkboxes) =>
  checkboxes.forEach((input) => {
    input.addEventListener('change', (e) => {
      const value = e.target.dataset.label
      const valueContainers = document.querySelectorAll(`[data-fyt-values="${e.target.dataset.parameter}"] ${selectors.researchModuleValuesContainer}`)

      valueContainers.forEach((container) => {
        const selectedValues = container.dataset.fytValuesContainer.split(', ')

        if (e.target.checked) {
          container.setAttribute('data-fyt-values-container', [...selectedValues, value].filter((i) => !!i).join(', '))
          container.innerText = [...selectedValues, value].filter((i) => !!i).join(', ')
        } else {
          container.setAttribute('data-fyt-values-container', selectedValues.filter((i) => !!i && i !== value).join(', '))
          container.innerText = selectedValues.filter((i) => !!i && i !== value).join(', ')
        }
      })
    })
  })

const handleTabClick = (headers, panes, activeIndex) => {
  const isActive = headers[activeIndex].classList.contains(selectors.active)

  headers.forEach((header, index) => {
    header.classList[index === activeIndex && !isActive ? 'add' : 'remove'](selectors.active)
  })
  panes.forEach((pane, index) => pane.classList[index === activeIndex && !isActive ? 'add' : 'remove'](selectors.active))

  //sendRequest(panes, activeIndex)
}

const initTabs = (tabs) => {
  const headers = tabs.querySelectorAll(`[${selectors.researchModuleTabsHeader}="${tabs.dataset.fytTabs}"]`)
  const panes = tabs.querySelectorAll(`[${selectors.researchModuleTabsPane}="${tabs.dataset.fytTabs}"]`)

  headers.forEach((header, activeIndex) => {
    header.addEventListener('click', () => handleTabClick(headers, panes, activeIndex))
  })

  // handleTabClick(headers, panes, 0)
}

const closeActiveItems = () => {
  const researchModule = document.querySelector(selectors.researchModule)
  researchModule?.classList.remove('active')
  researchModule?.querySelectorAll('.active').forEach(function (element) {
    element.classList.remove('active')
  })
}

const checkURLParams = () => {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)

  for (let [key, value] of params.entries()) {
    const checkbox = document.querySelector(`input[type="checkbox"][name="${key}"][value="${value}"]`)
    if (checkbox) {
      checkbox.checked = true
    }
  }
}

const clearURLParams = () => {
  const url = new URL(window.location.href)
  url.search = ''
  window.history.replaceState({}, '', url.toString())
}

const clearCheckboxesSnapshot = () => {
  checkboxesSnapshot = null
}

const initClearButtons = (clearButtons, checkboxes) => {
  clearButtons?.forEach((button) =>
    button.addEventListener('click', () => {
      const valuesContainers = document.querySelectorAll(selectors.researchModuleValuesContainer)

      if (form.hasAttribute('data-search-country')) {
        const value = form.getAttribute('data-search-country')
        checkboxes.forEach((checkbox) => {
          if (checkbox.value === value) {
            checkbox.checked = true
          } else {
            checkbox.checked = false
          }
        })
      } else {
        checkboxes.forEach((checkbox) => (checkbox.checked = false))
      }

      valuesContainers.forEach((container) => container.setAttribute('data-fyt-values-container', ''))

      clearURLParams()
      clearCheckboxesSnapshot()
      closeActiveItems()
      sendRequest(null, null, 1)
    })
  )
}

const initSubmitButtons = (submitButtons) => {
  submitButtons?.forEach((button) =>
    button.addEventListener('click', (e) => {
      e.preventDefault()
      closeActiveItems()
      document.body.classList.remove('no-scroll')
      sendRequest()
    })
  )
}

const initPagination = () => {
  const resultContainer = document.querySelector(selectors.researchModuleResult)

  resultContainer?.addEventListener('click', function (e) {
    //e.preventDefault();
    let paged = null
    const link = e.target.closest('.pagination a')
    if (link) {
      e.preventDefault()
      paged = link.dataset.paged
      const isPaginationRequest = true
      sendRequest(null, null, paged, isPaginationRequest)
    }
  })
}

const checkIsCountrySearch = () => {
  if (form.hasAttribute('data-search-country')) {
    const value = form.getAttribute('data-search-country')
    const inputs = document.querySelectorAll('input[type="checkbox"][name="country"]')
    inputs.forEach((input) => {
      if (input.value === value) {
        input.checked = true
      }
    })
    form.classList.add('fyt--country-search')
  }
}

const initLoadFirstResults = () => {
  checkURLParams()
  checkIsCountrySearch()
  sendRequest(null, null, 1)
}

const initResearchModule = (researchModule) => {
  const accordions = researchModule.querySelectorAll(selectors.researchModuleAccordion)
  const tabs = researchModule.querySelectorAll(selectors.researchModuleTabs)
  const checkboxes = researchModule.querySelectorAll(selectors.input)
  const clearButtons = researchModule.querySelectorAll(selectors.clearButton)
  const submitButtons = researchModule.querySelectorAll(selectors.submitButton)

  tabs.forEach(initTabs)

  initAccordions(accordions)
  initCheckboxes(checkboxes)
  initClearButtons(clearButtons, checkboxes)
  initSubmitButtons(submitButtons)
  initLoadFirstResults()
  initPagination()
}

const initResearchModuleTriggers = (researchModule, triggers) => {
  triggers.forEach((trigger) =>
    trigger.addEventListener('click', () => {
      researchModule.classList.toggle(selectors.active)
      document.body.classList.toggle('no-scroll')
    })
  )
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const researchModule = document.querySelector(selectors.researchModule)
    const triggers = document.querySelectorAll(selectors.researchModuleTrigger)

    if (!researchModule || !triggers) return

    initResearchModule(researchModule)
    initResearchModuleTriggers(researchModule, triggers)
  },
  { once: true }
)
